import React, { useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ModalHeader from "react-bootstrap/ModalHeader";
import QrReader from "react-qr-reader";

export default function QRCodeScannerModal({ show, toggleShow }) {
  const { t } = useTranslation();
  const [showClose, setShowClose] = useState(false);

  const isValidUrl = (input) => {
    try {
      const url = new URL(input);
      return !!url;
    } catch (e) {
      return false;
    }
  };

  const onHide = () => {
    setShowClose(false);
    toggleShow();
  };

  const onScan = (data) => {
    const isUrl = isValidUrl(data);

    if (isUrl) {
      const newTab = window.open(data, "_blank");
      if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
        window.alert(t("navMenu.popupError"));
      }
      onHide();
    }

    if (data && !isUrl) {
      window.alert(t("navMenu.invalidQrCode"));
    }
  };

  const onError = () => {
    window.alert(t("navMenu.scanError"));
    onHide();
  };

  const onLoad = () => {
    setShowClose(true);
  };

  return (
    <Modal
      backdropClassName="qrCodeBackDrop"
      show={show}
      onHide={onHide}
      dialogClassName="qrCodeDialog"
    >
      <div className="qr-code-scanner-wrapper">
        <ModalHeader closeButton={showClose} />
        <ModalBody className="modal-body">
          <h4>{t("qrCodeScanner.scan")}</h4>
          <div className="qr-code-reader-wrapper">
            <h4>{t("qrCodeScanner.enableAccess")}</h4>
            <QrReader
              className="qr-code-reader"
              showViewFinder={false}
              onScan={onScan}
              onError={onError}
              delay={1000}
              onLoad={onLoad}
            />
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
}
